<div class="container" *ngIf="data">
    <div class="box" (click)="open()">
        <div class="logo" [inlineSVG]="data.logo"></div>
        <div class="text" [ngClass]="boxStyle">{{ data?.text }}</div>
    </div>
</div>
